import { render, staticRenderFns } from "./InvitesDisabledIndication.vue?vue&type=template&id=1d38ffbc&scoped=true&"
import script from "./InvitesDisabledIndication.vue?vue&type=script&lang=js&"
export * from "./InvitesDisabledIndication.vue?vue&type=script&lang=js&"
import style0 from "./InvitesDisabledIndication.vue?vue&type=style&index=0&id=1d38ffbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d38ffbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d38ffbc')) {
      api.createRecord('1d38ffbc', component.options)
    } else {
      api.reload('1d38ffbc', component.options)
    }
    module.hot.accept("./InvitesDisabledIndication.vue?vue&type=template&id=1d38ffbc&scoped=true&", function () {
      api.rerender('1d38ffbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InvitesDisabledIndication.vue"
export default component.exports